import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const YorkUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="York University – Keele Campus"
      universityShortName="York University"
      slug="york-university"
      seoTitle="York University Study Rooms | Scott Library & Campus Study Guide"
      seoDescription="Complete guide to study rooms at York University Keele Campus. Find Scott Library, Bronfman Business Library, and Frost Library study spaces. Plus free 24/7 online alternative."
      seoKeywords="york university study rooms, scott library, bronfman business library, york u library, keele campus study, glendon frost library, york study spaces"
      canonicalUrl="/study-room/york-university/"
      heroDescription="A comprehensive guide to study rooms and spaces at York University's Keele and Glendon campuses, including Scott Library and Bronfman Business Library."
      libraryWebsiteUrl="https://www.library.yorku.ca/"
      libraryWebsiteName="York Libraries"
      studySpaces={[
        {
          name: "Scott Library (4th/5th Floors)",
          features: "Upper floors offer pin-drop silence and minimal distractions. Perfect for focused individual study.",
          feedback: "Students love the quiet on high floors but note that group rooms on lower floors are not fully soundproofed—conversations can leak between rooms."
        },
        {
          name: "Scott Library (2nd Floor & Collaboratory)",
          features: "More relaxed environments for group work with collaborative spaces and technology.",
          feedback: "Good for group projects but expect some ambient noise from other groups."
        },
        {
          name: "Bronfman Business Library (Schulich)",
          features: "2nd floor quiet area with natural light. Includes a Silent Study Room on the upper level where no talking, headphones or phone use is allowed. Group rooms can be booked and are enclosed.",
          feedback: "Highly rated for silence and natural lighting; however, group study rooms are popular and must be booked in advance. Food is not permitted in the Silent Study Room."
        },
        {
          name: "Steacie Science Library",
          features: "Quiet during exams with science-focused resources and study spaces.",
          feedback: "Seating can be limited during peak times like exam periods."
        },
        {
          name: "Frost Library (Glendon Campus)",
          features: "Offers individual study stations along windows with partitions and scenic views of the manor and rose garden.",
          feedback: "Students appreciate Frost's scenery and privacy; a hidden gem for peaceful studying."
        },
        {
          name: "Marsden Salon & Lounges",
          features: "Relaxing lounges in Scott Library; good for unwinding between study sessions.",
          feedback: "Not as quiet; suited for relaxing rather than exam prep."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            York's <strong>Scott Library</strong> is the go-to place for serious studying; the upper floors (4th and 5th) are almost whisper-free and perfect for focused work.
          </p>
          <p className="mb-4">
            For group projects, reserve rooms in <strong>Bronfman</strong> or <strong>Steacie</strong>—students prefer them because they are better enclosed and less prone to noise than those in Scott. If you crave nature, head to the <strong>Glendon campus</strong>: Frost Library's window seats overlook manicured gardens and provide a peaceful escape.
          </p>
          <p>
            One caution: York's group rooms are notorious for thin walls, so don't expect complete soundproofing. Bring headphones or book the <strong>Silent Study Room</strong> at Bronfman if absolute silence is essential.
          </p>
        </>
      }
      summaryTips={[
        "Head to upper floors for quiet: Scott Library's 4th and 5th floors offer the best silent study environment.",
        "Book Bronfman rooms for group work: Better soundproofing than Scott Library group rooms.",
        "Try Glendon's Frost Library: A hidden gem with beautiful garden views and partitioned study stations.",
        "Bring headphones: Group room walls at York are thin, so expect some noise bleed.",
        "Use CSW for guaranteed silence: When libraries are too loud or full, virtual study rooms offer peace."
      ]}
    />
  );
};

export default YorkUniversity;
